import { client } from '../common/services';
import { GenericGetFilterDto, NotificationResponseDto, PagedResponse } from "@bandido/shared/dtos";
import { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery, UseMutationOptions } from "react-query";
import { QueryKeys } from "./types";

interface useGetNotifications extends GenericGetFilterDto {
  onErrorCallback?: (_e: AxiosError) => void;
}

export const useGetNotifications = (params: useGetNotifications | undefined) => {
  const { currentPage = 1, pageSize = 0, search, onErrorCallback } = params || {};
  return useQuery({
    queryKey: [QueryKeys.getNotifications, currentPage, pageSize, search],
    queryFn: async (): Promise<PagedResponse<NotificationResponseDto> | undefined> => {
      try {
        const users: AxiosResponse<PagedResponse<NotificationResponseDto>, any> = await client.get(`notifications`, {
          params: {
            currentPage,
            pageSize,
            search,
          },
        });

        return users.data;
      } catch (e) {
        onErrorCallback && onErrorCallback(e as AxiosError);
      }
    },
    refetchOnWindowFocus: true,
  });
};

type MarkAllNotificationsResponse = { updatedCount: number };

export const useMarkAllNotificationsAsRead = (
  options?: UseMutationOptions<MarkAllNotificationsResponse, AxiosError>
) => {
  return useMutation(
    async (): Promise<MarkAllNotificationsResponse> => {
      const response = await client.patch('notifications/read-all');
      return response.data;
    },
    options,
  );
};

export const downloadFile = (fileId: number, returnUrl = false) => {
  const url = `/files/${fileId}`;
  return client.get(url, { responseType: 'blob' }).then((response) => {
    const type: string = response.headers['content-type'];
    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: type,
      }),
    );
    if (type.startsWith('audio/') || type.startsWith('video/') || returnUrl) {
      return url;
    }
    window.open(url);
  })
};
